var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1713 8.36824H17.5001V8.33366H10.0001V11.667H14.7097C14.0226 13.6074 12.1763 15.0003 10.0001 15.0003C7.23883 15.0003 5.00008 12.7616 5.00008 10.0003C5.00008 7.23908 7.23883 5.00033 10.0001 5.00033C11.2747 5.00033 12.4342 5.48116 13.3172 6.26658L15.6742 3.90949C14.1859 2.52241 12.1951 1.66699 10.0001 1.66699C5.398 1.66699 1.66675 5.39824 1.66675 10.0003C1.66675 14.6024 5.398 18.3337 10.0001 18.3337C14.6022 18.3337 18.3334 14.6024 18.3334 10.0003C18.3334 9.44158 18.2759 8.89616 18.1713 8.36824Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.62744 6.12158L5.36536 8.12949C6.10619 6.29533 7.90036 5.00033 9.99994 5.00033C11.2745 5.00033 12.4341 5.48116 13.317 6.26658L15.6741 3.90949C14.1858 2.52241 12.1949 1.66699 9.99994 1.66699C6.79911 1.66699 4.02327 3.47408 2.62744 6.12158Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 18.3336C12.1525 18.3336 14.1084 17.5099 15.5871 16.1703L13.008 13.9878C12.1432 14.6454 11.0865 15.0011 10 15.0003C7.83255 15.0003 5.99213 13.6182 5.2988 11.6895L2.5813 13.7832C3.96047 16.482 6.7613 18.3336 10 18.3336Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.1712 8.36759H17.5V8.33301H10V11.6663H14.7096C14.3809 12.5898 13.7889 13.3968 13.0067 13.9876L13.0079 13.9868L15.5871 16.1693C15.4046 16.3351 18.3333 14.1663 18.3333 9.99967C18.3333 9.44092 18.2758 8.89551 18.1712 8.36759Z",
    fill: "#0C579B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.39721fe68ff5625ab21bb88ec675ec0f.svg";
export { ForwardRef as ReactComponent };